// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d04ed61","453":"3034f108","455":"5be69bbc","977":"4f3ca74f"}[chunkId] + ".chunk.js";
};